import React, { useState } from 'react';
import useManageUser from './useManageUser';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ForgotPassword = () => {
  const { error, forgotPassword } = useManageUser();
  const [email, setEmail] = useState('')

  const handleLogin = async (e) => {

  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="max-w-md w-full"> {/* This div will act as the card */}
          <div className="bg-white shadow-lg rounded-lg px-8 py-10"> {/* Card styling */}
          <div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Forgot Password
            </h2>
            <p className='text-gray-600 text-sm'>Enter your email and we'll send you a link to reset your password.</p>
          </div>
          <form className="mt-8" onSubmit={handleLogin} method="post">
            <div className='flex'>
              <input
                id="email"
                name="email"
                type="string"
                required
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Email"
              />
            </div>
            <div className='mt-4'>
              <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
